import ResourceApi from '../ResourceApi';

const UserMeetingResource = {
  index: async (userId, params = {}) => (await ResourceApi.get(`/resource/users/${userId}/meetings`, params)).data,
  post: async (userId, params = {}) => (await ResourceApi.post(`/resource/users/${userId}/meetings`, params)).data,
  patch: async (userId, meetingId, params = {}) => (await ResourceApi.patch(`/resource/users/${userId}/meetings/${meetingId}`, params)).data,
  destroy: async (userId, params = {}) => (await ResourceApi.destroy(`/resource/users/${userId}/meetings`, params)).data,
};

export default UserMeetingResource;
